import React from 'react';
import PriorityDashboard from '../components/PriorityDashboard';

/**
 * PriorityQueuePage — Doctor's priority patient queue.
 */
const PriorityQueuePage = () => {
  return (
    <div className="py-6">
      <PriorityDashboard />
    </div>
  );
};

export default PriorityQueuePage;
